export const gerarDiasDoMes = (ano: number, mes: number) => {
  const dias: { dia: number | null; data: Date | null }[][] = [];
  const primeiroDia = new Date(ano, mes, 1);
  const ultimoDia = new Date(ano, mes + 1, 0);
  const totalDias = ultimoDia.getDate();
  const diaSemanaInicial = primeiroDia.getDay();

  let semana: { dia: number | null; data: Date | null }[] = [];

  for (let i = 0; i < diaSemanaInicial; i++) {
    semana.push({ dia: null, data: null });
  }

  for (let i = 1; i <= totalDias; i++) {
    semana.push({ dia: i, data: new Date(ano, mes, i) });
    if (semana.length === 7) {
      dias.push(semana);
      semana = [];
    }
  }

  if (semana.length > 0) {
    while (semana.length < 7) {
      semana.push({ dia: null, data: null });
    }
    dias.push(semana);
  }

  return dias;
};
